import * as types from "../types_iprange";
import axios from "axios/index";
import authHeader from "../../authHeader";

const state = {
  iprange: {
    isLoading: false,
    isError: false,
    data: "",
    requests: [],
    filter: {
      partyName: "",
      username: "",
      email: "",
      institution: "",
      partners: [],
      partyTypes: [],
      userIdentifier: "",
      firstName: "",
      lastName: "",
    },
  },
};

const getters = {
  isError: (state) => {
    return state.iprange.isError;
  },
  isLoading: (state) => {
    return state.iprange.isLoading;
  },
  ipRangeData: (state) => {
    return state.iprange.data;
  },
  filter: (state) => {
    return state.iprange.filter;
  },
  requests: (state) => {
    return state.iprange.requests;
  },
};

const mutations = {
  // [types.IPR_MUTATION_CLEAR_FILTER]: (state, payload) => {
  //   state.iprange.filter.partyTypes = [];
  //   state.iprange.filter.partyName = "";
  //   state.iprange.filter.username = "";
  //   state.iprange.filter.email = "";
  //   state.iprange.filter.institution = "";
  //   state.iprange.filter.partners = [];
  //   state.iprange.filter.userIdentifier = "";
  //   state.iprange.filter.firstName = "";
  //   state.iprange.filter.lastName = "";
  // },
  // [types.IPR_MUTATION_FILTER_EMAIL]: (state, email) => {
  //   state.iprange.filter.partyEmail = email;
  // },
};

const actions = {
  setFilter: (context, payload) => {
    context.state.iprange.filter = payload;
    context.state.iprange.isLoading = true;
    let headers = authHeader();
    axios({
      method: "POST",
      url: "/iprange/filter",
      data: context.state.iprange.filter,
      headers: headers,
    })
      .then((res) => {
        let finalData = res.data;
        finalData = finalData.filter((party) => {
          return party.name != "";
        });
        context.state.iprange.data = finalData;
        context.state.iprange.isLoading = false;
        context.state.iprange.isError = false;
      })
      .catch((error) => {
        context.state.iprange.isLoading = false;
        context.state.iprange.isError = true;
      });
  },
  setRequests: (context, payload) => {
    let headers = authHeader();
    axios({
      method: "GET",
      url: "/iprange/requests",
      headers: headers,
    })
      .then((res) => {
        let finalData = res.data;
        // console.log({ finalData });
        context.state.iprange.requests = finalData;
      })
      .catch((error) => {});
  },
  addRequest: (context, payload) => {
    let headers = authHeader();
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/iprange/request",
        data: payload,
        headers: headers,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error.response.data.message);
        });
    });
  },
  deleteRequest: (context, payload) => {
    let headers = authHeader();
    console.log(payload);
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        url: `/iprange/request?requestId=${payload.id}`,
        headers: headers,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error.response.data.message);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/iprange.js